export default `
* {
	font-family: "Calibri", sans-serif !important;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

@page {
	size: A4 portrait;
	margin: 10mm;
}

html, body {
	margin: 0;
	padding: 0;
	width: 100%;
	background: #fff;
}

.text-center {
	text-align: center;
}

.header-client-name {
	font-size: 26pt;
	color: #c5a069;
	line-height: 1.25;
	margin-top: 12px;
}

.header-program-info {
	font-size: 10.5pt;
	color: #c5a069;
	margin-top: 10px;
	line-height: 1.4;
}

.header-logo {
	height: 120px;
	width: auto;
	max-width: 100%;
	object-fit: contain;
	object-position: center;
	display: block;
	margin: 0 auto;
}

.header-logo-slot {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}

.header-logo-slot--cover {
	width: min(150mm, 92%);
	height: 55mm;
	min-height: 55mm;
	box-sizing: border-box;
}

.header-logo-slot--cover.header-logo-slot--client {
	padding: 7mm 3mm;
}

.header-logo-slot--compact {
	height: 90px;
	min-height: 90px;
}

.header-logo--cover {
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
	margin: 0;
	object-fit: contain;
	object-position: center;
}

.header-logo--compact {
	height: auto;
	max-height: 100%;
	width: auto;
}

.header-details {
	width: 100%;
}

.header-details--cover {
	margin-top: 18mm;
}

.header-details--cover .header-client-name {
	margin-top: 0;
	font-size: 24pt;
	font-weight: 400;
	letter-spacing: 0.01em;
}

.header-details--cover .header-program-info {
	margin-top: 2.5mm;
	font-size: 10pt;
	font-weight: 400;
}

.program-header--cover {
	width: 100%;
}

.program-header--cover .header-client-name {
	margin-top: 18mm;
	font-size: 24pt;
	font-weight: 400;
	letter-spacing: 0.01em;
}

.program-header--cover .header-program-info {
	margin-top: 2.5mm;
	font-size: 10pt;
	font-weight: 400;
}

.program-cover-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 12mm;
}

.program-overview-page {
	align-items: stretch;
}

.program-overview {
	display: flex;
	flex-direction: column;
	gap: 0;
	width: 100%;
	margin: 0;
	min-width: 0;
	flex: 1 1 auto;
}

.program-overview__section {
	min-width: 0;
}

.program-overview__section--table {
	margin-top: 9mm;
	/* Smaller than top: the successes block starts with a 52px icon heading,
	   which otherwise makes the gap after the table look larger. */
	margin-bottom: 4mm;
}

.program-overview__heading {
	display: flex;
	align-items: flex-start;
	gap: 2.5mm;
	margin-bottom: 2.5mm;
}

.program-overview__icon {
	width: 52px;
	height: 52px;
	object-fit: contain;
	flex: 0 0 auto;
	display: block;
}

.program-overview__title {
	font-size: 13.5pt;
	font-weight: 700;
	color: #c5a069;
	line-height: 1.25;
	padding-top: 2mm;
}

.program-overview__title em {
	font-style: italic;
	font-weight: 700;
}

.program-overview__body {
	font-size: 10.5pt;
	color: #333333;
	white-space: pre-line;
	text-align: justify;
	text-align-last: left;
	line-height: 1.4;
	padding-left: 6mm;
}

.program-overview__table {
	width: 100%;
	border-collapse: collapse;
	table-layout: fixed;
	font-size: 10.5pt;
	color: #333333;
	margin: 0;
}

.program-overview__col-day {
	width: 18%;
}

.program-overview__col-route {
	width: 54%;
}

.program-overview__col-trip {
	width: 28%;
}

.program-overview__table th,
.program-overview__table td {
	box-sizing: border-box;
	padding: 1.8mm 2.5mm;
	vertical-align: middle;
}

.program-overview__table th {
	font-weight: 700;
	text-align: center;
}

.program-overview__table th:not(:last-child),
.program-overview__table td:not(:last-child) {
	border-right: 0.3mm solid #bdbdbd;
}

.program-overview__table td {
	border-bottom: 0.3mm solid #d0d0d0;
}

.program-overview__table tbody tr:last-child td {
	border-bottom: none;
}

.program-overview__cell-day {
	text-align: center;
}

.program-overview__cell-day sup {
	font-size: 0.65em;
}

.program-overview__cell-route {
	text-align: left;
}

.program-overview__cell-trip {
	text-align: center;
	white-space: nowrap;
}

.program-overview__list {
	margin: 0;
	padding-left: 6mm;
	font-size: 10.5pt;
	color: #333333;
	line-height: 1.45;
}

.program-overview__list li {
	margin-bottom: 1.5mm;
	text-align: justify;
	text-align-last: left;
}

.program-overview__list strong {
	font-weight: 700;
}

.program-prices-page {
	align-items: stretch;
}

.program-prices {
	display: flex;
	flex-direction: column;
	gap: 7mm;
	width: 100%;
	margin: 0;
	min-width: 0;
	flex: 1 1 auto;
}

.program-prices__title {
	margin: 0;
	font-size: 22pt;
	font-weight: 400;
	color: #c5a069;
	text-align: center;
	line-height: 1.2;
	padding-bottom: 2.5mm;
	border-bottom: 0.3mm solid #d7c4a4;
}

.program-prices__intro,
.program-prices__disclaimer {
	display: flex;
	gap: 2.5mm;
}

.program-prices__intro {
	align-items: center;
}

.program-prices__disclaimer {
	align-items: flex-start;
}

.program-prices__icon {
	width: 64px;
	height: 64px;
	object-fit: contain;
	flex: 0 0 auto;
	display: block;
}

.program-prices__intro-text {
	font-size: 11pt;
	color: #333333;
	line-height: 1.35;
	flex: 1 1 auto;
	min-width: 0;
	text-align: justify;
	text-align-last: left;
}

.program-prices__tables {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 4.5mm;
	width: 100%;
}

.program-prices__table {
	width: 100%;
	border-collapse: collapse;
	table-layout: fixed;
	font-size: 10.5pt;
	color: #333333;
}

.program-prices__table--supplements {
	font-size: 9.5pt;
}

.program-prices__col-first {
	width: 24%;
}

.program-prices__table th,
.program-prices__table td {
	box-sizing: border-box;
	padding: 1.8mm 2mm;
	vertical-align: middle;
	text-align: center;
}

.program-prices__table--supplements th,
.program-prices__table--supplements td {
	padding: 1.3mm 1.6mm;
}

.program-prices__table th:first-child,
.program-prices__table td:first-child {
	width: 24%;
}

.program-prices__table th {
	font-weight: 700;
	color: #c5a069;
	padding-top: 0;
	padding-bottom: 2mm;
}

.program-prices__table th:not(:last-child),
.program-prices__table td:not(:last-child) {
	border-right: 0.3mm solid #bdbdbd;
}

.program-prices__table td {
	border-bottom: 0.3mm solid #d0d0d0;
}

.program-prices__table tbody tr:last-child td {
	border-bottom: none;
}

.program-prices__label {
	text-align: left;
}

.program-prices__list {
	margin: 0;
	padding-left: 5mm;
	font-size: 8.5pt;
	color: #777777;
	line-height: 1.25;
	flex: 1 1 auto;
	min-width: 0;
}

.program-prices__list li {
	margin-bottom: 0.4mm;
	text-align: justify;
	text-align-last: left;
}

.program-accommodations-page {
	align-items: stretch;
}

.program-accommodations {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0;
	min-width: 0;
	flex: 1 1 auto;
}

.program-accommodations__title {
	margin: 0;
	font-size: 22pt;
	font-weight: 400;
	color: #c5a069;
	text-align: center;
	line-height: 1.2;
	padding-bottom: 2.5mm;
	border-bottom: 0.3mm solid #111;
}

.program-accommodations__list {
	list-style: none;
	margin: 7mm 0 0;
	padding: 0;
}

.program-accommodations__item {
	position: relative;
	padding-left: 5mm;
	margin: 0 0 4.5mm;
}

.program-accommodations__item::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0.55em;
	width: 1.6mm;
	height: 1.6mm;
	border-radius: 50%;
	background: #c5a36d;
}

.program-accommodations__description {
	font-size: 11pt;
	font-weight: 700;
	color: #333333;
	line-height: 1.3;
}

.program-accommodations__name {
	font-size: 10.5pt;
	font-weight: 400;
	color: #777777;
	line-height: 1.35;
	margin-top: 0.5mm;
}

.program-accommodations__website {
	display: inline-block;
	margin-top: 0.5mm;
	font-size: 10.5pt;
	font-weight: 400;
	color: #c5a069;
	text-decoration: underline;
	line-height: 1.35;
}

.program-accommodations__empty {
	display: none;
}

.program-accommodations__image-controls {
	display: none !important;
}

.program-accommodations__images {
	margin-top: auto;
	padding-top: 5mm;
}

.program-cover-top {
	width: 100%;
	flex: 0 0 auto;
	text-align: center;
}

.program-cover-image {
	position: relative;
	width: 100%;
	flex: 0 0 auto;
	margin-top: 14mm;
	overflow: hidden;
	background: #fff;
}

.program-cover-image__img {
	width: 100%;
	min-width: 100%;
	height: 90mm;
	max-height: 100mm;
	object-fit: cover;
	object-position: center;
	display: block;
}

.program-cover-image__placeholder {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 90mm;
	text-align: center;
	color: #9e9e9e;
	font-size: 12px;
	background: #f5f5f5;
}

.program-cover-image__fallback {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 14px;
	width: 100%;
	height: 90mm;
	box-sizing: border-box;
	border: 1px solid #e4d4b5;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0.15) 45%, transparent 100%),
		linear-gradient(135deg, #f7f1e6 0%, #efe2c8 48%, #e6d3ae 100%);
}

.program-cover-image__fallback-stars {
	width: 42px;
	height: 42px;
	object-fit: contain;
	opacity: 0.92;
}

.program-cover-image__fallback-line {
	width: 48px;
	height: 1.5px;
	background: #c5a36d;
	opacity: 0.7;
}

.program-document {
	display: block;
	gap: 0;
	background: #fff;
}

.program-measure {
	display: none !important;
}

.program-page {
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	width: 190mm;
	min-height: 277mm;
	height: 277mm;
	max-height: 277mm;
	padding: 10mm 11mm 9mm;
	margin: 0 auto 0;
	overflow: hidden;
	background: #fff;
	border: none;
	box-shadow: none;
	page-break-after: always;
	page-break-inside: avoid;
	break-after: page;
	break-inside: avoid;
}

.program-page--last {
	page-break-after: auto;
	break-after: auto;
}

.program-page-header {
	margin-bottom: 6mm;
	flex: 0 0 auto;
}

.program-day {
	display: flex;
	flex-direction: column;
	margin-bottom: 5mm;
	page-break-inside: avoid;
	break-inside: avoid;
	flex: 0 0 auto;
}

.program-day__main {
	display: grid;
	grid-template-columns: 40px 1fr;
	column-gap: 14px;
	align-items: stretch;
}

.program-day__rail {
	position: relative;
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	box-sizing: border-box;
	border-right: 2px solid #c5a36d;
	padding-right: 7px;
	width: 100%;
	align-self: stretch;
	min-height: 36px;
}

.program-day__stars {
	position: static;
	width: 32px;
	height: 32px;
	margin-top: -1px;
	object-fit: contain;
	display: block;
	flex: 0 0 auto;
}

.program-day__content {
	min-width: 0;
}

.program-day__details {
	margin-left: 0;
}

.program-day__title {
	font-size: 11pt;
	font-weight: 700;
	color: #333333;
	line-height: 1.25;
	margin-bottom: 6px;
}

.program-day__title sup {
	font-size: 0.65em;
}

.program-day__cities {
	font-size: 10.5pt;
	font-weight: 700;
	color: #333333;
	margin-bottom: 14px;
	line-height: 1.3;
}

.program-day__paragraph {
	font-size: 10.5pt;
	color: #777777;
	white-space: pre-line;
	margin-bottom: 8px;
	line-height: 1.35;
	text-align: justify;
	text-align-last: left;
}

.program-day__placeholder {
	font-size: 10.5pt;
	color: #9e9e9e;
	margin-bottom: 8px;
}

.program-day__bullet {
	position: relative;
	font-size: 10.5pt;
	color: #777777;
	white-space: pre-line;
	margin: 0 0 8px 10px;
	padding-left: 14px;
	line-height: 1.35;
	text-align: justify;
	text-align-last: left;
}

.program-day__bullet::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0.45em;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #c5a36d;
}

.program-day__bullet-title {
	font-weight: 700;
	color: #c5a36d;
	margin-right: 4px;
}

.program-day__bullet-body {
	color: #777777;
}

.program-day__footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-top: 22px;
	padding-left: 54px;
}

.program-day__meals,
.program-day__stay {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	font-size: 10.5pt;
	color: #777777;
	line-height: 1.3;
}

.program-day__stay {
	margin-left: auto;
	text-align: right;
}

.program-day__footer-icon {
	width: 36px;
	height: 36px;
	object-fit: contain;
	flex: 0 0 auto;
	display: block;
}

.program-page-images {
	display: flex;
	gap: 12px;
	margin-top: auto;
	padding-top: 4mm;
	flex: 0 0 auto;
	page-break-inside: avoid;
	page-break-before: avoid;
	break-inside: avoid;
	break-before: avoid;
}

.program-page-images__controls {
	display: none !important;
}

.program-page-image {
	position: relative;
	flex: 1 1 0;
	min-width: 0;
	height: 42mm;
	overflow: hidden;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}

.program-page-image__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	display: block;
}

.program-page-image__placeholder {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	padding: 8px;
	text-align: center;
	color: #9e9e9e;
	font-size: 12px;
	background: #f5f5f5;
}

.program-page-image__fallback {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 14px;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: 1px solid #e4d4b5;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0.15) 45%, transparent 100%),
		linear-gradient(135deg, #f7f1e6 0%, #efe2c8 48%, #e6d3ae 100%);
}

.program-page-image__fallback-stars {
	width: 42px;
	height: 42px;
	object-fit: contain;
	opacity: 0.92;
}

.program-page-image__fallback-line {
	width: 48px;
	height: 1.5px;
	background: #c5a36d;
	opacity: 0.7;
}

.program-extra-pages__controls,
.no-print {
	display: none !important;
}

.program-extra-page__inner {
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
}

.program-extra-page__title-block {
	text-align: center;
	margin: 4px 0 24px;
}

.program-extra-page__eyebrow {
	font-family: "Calibri", sans-serif;
	font-size: 11pt;
	font-weight: 400;
	color: #c5a069;
	line-height: 1.4;
	margin: 0 0 8px;
}

.program-extra-page__title {
	font-family: "Calibri", sans-serif;
	font-size: 16pt;
	font-weight: 700;
	margin: 0 auto;
	max-width: 92%;
	color: #c5a069;
	line-height: 1.35;
	white-space: pre-line;
}

.program-extra-page__title-rule {
	width: 86%;
	max-width: 640px;
	height: 1px;
	margin: 16px auto 0;
	background: #111;
}

.program-extra-page__html {
	font-size: 13px;
	line-height: 1.35;
	color: #2a2a2a;
}

.program-extra-page__html h1,
.program-extra-page__html h2,
.program-extra-page__html h3 {
	margin: 0 0 10px;
	font-weight: 700;
}

.program-extra-page__html p {
	margin: 0 0 10px;
}

.program-extra-page__html ul,
.program-extra-page__html ol {
	margin: 0 0 12px;
	padding-left: 20px;
}

.program-extra-page__html img {
	display: inline-block;
	vertical-align: top;
	max-width: 100%;
	height: auto;
	margin: 4px 6px 8px 0;
}

.program-extra-page__html .rte-columns {
	display: flex;
	gap: 4mm;
	width: 100%;
	margin: 3mm 0;
	align-items: flex-start;
	box-sizing: border-box;
}

.program-extra-page__html .rte-columns--icon > .rte-column:first-child {
	flex: 0 0 18mm;
	max-width: 18mm;
	min-width: 18mm;
}

.program-extra-page__html .rte-columns--icon > .rte-column:last-child {
	flex: 1 1 auto;
}

.program-extra-page__html .rte-columns--icon > .rte-column:first-child img {
	width: 100%;
	max-width: 16mm;
	height: auto;
	margin: 0;
}

.program-extra-page__html .rte-column {
	flex: 1 1 0;
	min-width: 0;
	box-sizing: border-box;
}

.program-extra-page--map .program-extra-page__inner {
	padding: 0 16px 16px;
}

.program-extra-page--map .program-extra-page__html img {
	width: 100%;
	max-height: 780px;
	object-fit: contain;
}

.clear-btn,
.v-btn {
	display: none !important;
}

.editable-area {
	border: none !important;
	cursor: default !important;
}
`;
